import { useEffect, useState } from "react";
import { isNumeric } from "../util/type-utils";

export default function useSets(records) {
  const [recordsSets, setRecordsSets] = useState([]);
  useEffect(() => {
    if (records) {
      const transformedRecords = records.reduce((resArr, record) => {
        const {
          title: [character],
        } = record;
        if (!isNumeric(character)) {
          resArr = createSet(resArr, character, record);
        } else {
          resArr = createSet(resArr, numericCharacter, record);
        }
        return resArr;
      }, []);
      setRecordsSets(transformedRecords);
    }
  }, [records]);

  const numericCharacter = "#";

  const createSet = (arr, char, item) => {
    const match = arr.find(
      (el) => el.char.toLocaleLowerCase() === char.toLocaleLowerCase()
    );
    if (!match) {
      return arr.concat({
        char,
        id: char,
        isActive: !arr.length,
        list: [item],
      });
    }
    match.list.push(item);

    return arr;
  };

  return {
    recordsSets,
  };
}
